import SalesStep1Component from './SalesStep1';

export { SalesStep1Component as SalesStep1 };
export { useSalesStep1 } from './SalesStep1.hooks';
export * from './SalesStep1.styles';

export default SalesStep1Component;
